export const RESET_SKILLS = "RESET_SKILLS";
export const GET_SKILLS = "GET_SKILLS";
export const SET_SKILLS = "SET_SKILLS";

export const API_ERROR = "SKILLS_API_ERROR";

export const GET_SKILL = "GET_SKILL";
export const SET_SKILL = "PATCH_SKILL";